import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon, Tooltip } from 'antd';
import './ModuleEmptyState.scss';

/**
 * Organisation / module empty-screen layout (aligned with design spec): title row + divider + centred illustration, copy, CTAs and optional tip.
 */
function ModuleEmptyState({
  moduleTitle,
  tooltipContent,
  headline,
  description,
  tip,
  iconType = 'user',
  embedded = false,
  children
}) {
  return (
    <div className={classNames('module-empty-state', { 'module-empty-state--embedded': embedded })}>
      {!embedded ? (
        <>
          <header className="module-empty-state__header">
            <h2 className="module-empty-state__title">{moduleTitle}</h2>
            {tooltipContent ? (
              <Tooltip
                title={tooltipContent}
                overlayClassName="module-empty-state__tooltip"
                placement="bottomLeft"
              >
                <button type="button" className="module-empty-state__info" aria-label="About this section">
                  <Icon type="info-circle" />
                </button>
              </Tooltip>
            ) : null}
          </header>
          <hr className="module-empty-state__rule" />
        </>
      ) : null}

      <div className="module-empty-state__centre">
        <div className="module-empty-state__icon-ring" aria-hidden>
          <Icon type={iconType} />
        </div>
        <h3 className="module-empty-state__headline">{headline}</h3>
        <p className="module-empty-state__description">{description}</p>
        {children ? (
          <div className="module-empty-state__actions">{children}</div>
        ) : null}
        {tip ? (
          <p className="module-empty-state__tip">{tip}</p>
        ) : null}
      </div>
    </div>
  );
}

ModuleEmptyState.propTypes = {
  moduleTitle: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  tooltipContent: PropTypes.node,
  tip: PropTypes.node,
  iconType: PropTypes.string,
  embedded: PropTypes.bool,
  children: PropTypes.node
};

ModuleEmptyState.defaultProps = {
  tooltipContent: null,
  tip: null,
  iconType: 'user',
  embedded: false,
  children: null
};

export default ModuleEmptyState;
